import "core-js/modules/es6.string.fixed";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.function.bind";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.string.starts-with";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.string.trim";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.object.assign";
import React, { Children, cloneElement, createElement } from 'react';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var globalModule = {
  "cursor-pointer": "_17_OS",
  "selection-control-container": "_jzWXa",
  "d-dummy": "_1TF7v"
};

var getModuleClasses = function getModuleClasses(localModule, classNames) {
  var styles = _extends(_extends({}, localModule), globalModule);

  return classNames.replace(/^\s+|\s+$/g, '').split(/\s+/).map(function (cl) {
    return styles[cl.trim()];
  }).join(' ').trim();
};

var callCallback = function callCallback(callback, data) {
  if (callback && typeof callback === 'function') {
    callback(data);
  }
};

var uid = function uid() {
  return "_" + ((1 + Math.random()) * 0x10000 | 0).toString(8).substring(1) + "_";
};

var setCSSVariable = function setCSSVariable(element, variable, value) {
  if (element && value) {
    element.style.setProperty(variable, String(value));
  }
};

var overrideThemeVariables = function overrideThemeVariables(themeObject) {
  var root = document.querySelector(':root');
  var themeVariables = Object.keys(themeObject);

  if (root) {
    themeVariables.forEach(function (themeVar) {
      var varValue = themeObject[themeVar];

      if (varValue && themeVar.startsWith('--')) {
        setCSSVariable(root, themeVar, varValue);
      }
    });
  }
};

var isMyReactComponent = function isMyReactComponent(component) {
  var componentName = '';

  if (component && component.type && typeof component.type !== 'string') {
    componentName = component.type.displayName;
  }

  return componentName && componentName.includes('Nu');
};

var passDownProp = function passDownProp(children, props, propName) {
  return Children.map(children, function (child) {
    if (isMyReactComponent(child)) {
      var newProps = _extends({}, child.props);

      if (typeof propName === 'string') {
        newProps[propName] = child.props[propName] === undefined ? props[propName] : child.props[propName];
      } else if (Array.isArray(propName)) {
        propName.forEach(function (prop) {
          newProps[prop] = child.props[prop] === undefined ? props[prop] : child.props[prop];
        });
      }

      return cloneElement(child, newProps);
    } else {
      return child;
    }
  });
};

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */


var b = "function" === typeof Symbol && Symbol["for"],
    c = b ? Symbol["for"]("react.element") : 60103,
    d = b ? Symbol["for"]("react.portal") : 60106,
    e = b ? Symbol["for"]("react.fragment") : 60107,
    f = b ? Symbol["for"]("react.strict_mode") : 60108,
    g = b ? Symbol["for"]("react.profiler") : 60114,
    h = b ? Symbol["for"]("react.provider") : 60109,
    k = b ? Symbol["for"]("react.context") : 60110,
    l = b ? Symbol["for"]("react.async_mode") : 60111,
    m = b ? Symbol["for"]("react.concurrent_mode") : 60111,
    n = b ? Symbol["for"]("react.forward_ref") : 60112,
    p = b ? Symbol["for"]("react.suspense") : 60113,
    q = b ? Symbol["for"]("react.suspense_list") : 60120,
    r = b ? Symbol["for"]("react.memo") : 60115,
    t = b ? Symbol["for"]("react.lazy") : 60116,
    v = b ? Symbol["for"]("react.block") : 60121,
    w = b ? Symbol["for"]("react.fundamental") : 60117,
    x = b ? Symbol["for"]("react.responder") : 60118,
    y = b ? Symbol["for"]("react.scope") : 60119;

function z(a) {
  if ("object" === typeof a && null !== a) {
    var u = a.$$typeof;

    switch (u) {
      case c:
        switch (a = a.type, a) {
          case l:
          case m:
          case e:
          case g:
          case f:
          case p:
            return a;

          default:
            switch (a = a && a.$$typeof, a) {
              case k:
              case n:
              case t:
              case r:
              case h:
                return a;

              default:
                return u;
            }

        }

      case d:
        return u;
    }
  }
}

function A(a) {
  return z(a) === m;
}

var AsyncMode = l;
var ConcurrentMode = m;
var ContextConsumer = k;
var ContextProvider = h;
var Element = c;
var ForwardRef = n;
var Fragment = e;
var Lazy = t;
var Memo = r;
var Portal = d;
var Profiler = g;
var StrictMode = f;
var Suspense = p;

var isAsyncMode = function isAsyncMode(a) {
  return A(a) || z(a) === l;
};

var isConcurrentMode = A;

var isContextConsumer = function isContextConsumer(a) {
  return z(a) === k;
};

var isContextProvider = function isContextProvider(a) {
  return z(a) === h;
};

var isElement = function isElement(a) {
  return "object" === typeof a && null !== a && a.$$typeof === c;
};

var isForwardRef = function isForwardRef(a) {
  return z(a) === n;
};

var isFragment = function isFragment(a) {
  return z(a) === e;
};

var isLazy = function isLazy(a) {
  return z(a) === t;
};

var isMemo = function isMemo(a) {
  return z(a) === r;
};

var isPortal = function isPortal(a) {
  return z(a) === d;
};

var isProfiler = function isProfiler(a) {
  return z(a) === g;
};

var isStrictMode = function isStrictMode(a) {
  return z(a) === f;
};

var isSuspense = function isSuspense(a) {
  return z(a) === p;
};

var isValidElementType = function isValidElementType(a) {
  return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};

var typeOf = z;
var reactIs_production_min = {
  AsyncMode: AsyncMode,
  ConcurrentMode: ConcurrentMode,
  ContextConsumer: ContextConsumer,
  ContextProvider: ContextProvider,
  Element: Element,
  ForwardRef: ForwardRef,
  Fragment: Fragment,
  Lazy: Lazy,
  Memo: Memo,
  Portal: Portal,
  Profiler: Profiler,
  StrictMode: StrictMode,
  Suspense: Suspense,
  isAsyncMode: isAsyncMode,
  isConcurrentMode: isConcurrentMode,
  isContextConsumer: isContextConsumer,
  isContextProvider: isContextProvider,
  isElement: isElement,
  isForwardRef: isForwardRef,
  isFragment: isFragment,
  isLazy: isLazy,
  isMemo: isMemo,
  isPortal: isPortal,
  isProfiler: isProfiler,
  isStrictMode: isStrictMode,
  isSuspense: isSuspense,
  isValidElementType: isValidElementType,
  typeOf: typeOf
};
var reactIs_development = createCommonjsModule(function (module, exports) {
  if (process.env.NODE_ENV !== "production") {
    (function () {
      // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
      // nor polyfill, then a plain number is used for performance.
      var hasSymbol = typeof Symbol === 'function' && Symbol["for"];
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol["for"]('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol["for"]('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol["for"]('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol["for"]('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol["for"]('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol["for"]('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol["for"]('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
      // (unstable) APIs that have been removed. Can we remove the symbols?

      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol["for"]('react.async_mode') : 0xeacf;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol["for"]('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol["for"]('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol["for"]('react.suspense') : 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol["for"]('react.suspense_list') : 0xead8;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol["for"]('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol["for"]('react.lazy') : 0xead4;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol["for"]('react.block') : 0xead9;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol["for"]('react.fundamental') : 0xead5;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol["for"]('react.responder') : 0xead6;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol["for"]('react.scope') : 0xead7;

      function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }

      function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
          var $$typeof = object.$$typeof;

          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;

              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;

                default:
                  var $$typeofType = type && type.$$typeof;

                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;

                    default:
                      return $$typeof;
                  }

              }

            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }

        return undefined;
      } // AsyncMode is deprecated along with isAsyncMode


      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

            console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }

      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }

      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }

      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }

      function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }

      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }

      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }

      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }

      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }

      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }

      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }

      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }

      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }

      exports.AsyncMode = AsyncMode;
      exports.ConcurrentMode = ConcurrentMode;
      exports.ContextConsumer = ContextConsumer;
      exports.ContextProvider = ContextProvider;
      exports.Element = Element;
      exports.ForwardRef = ForwardRef;
      exports.Fragment = Fragment;
      exports.Lazy = Lazy;
      exports.Memo = Memo;
      exports.Portal = Portal;
      exports.Profiler = Profiler;
      exports.StrictMode = StrictMode;
      exports.Suspense = Suspense;
      exports.isAsyncMode = isAsyncMode;
      exports.isConcurrentMode = isConcurrentMode;
      exports.isContextConsumer = isContextConsumer;
      exports.isContextProvider = isContextProvider;
      exports.isElement = isElement;
      exports.isForwardRef = isForwardRef;
      exports.isFragment = isFragment;
      exports.isLazy = isLazy;
      exports.isMemo = isMemo;
      exports.isPortal = isPortal;
      exports.isProfiler = isProfiler;
      exports.isStrictMode = isStrictMode;
      exports.isSuspense = isSuspense;
      exports.isValidElementType = isValidElementType;
      exports.typeOf = typeOf;
    })();
  }
});
var reactIs = createCommonjsModule(function (module) {
  if (process.env.NODE_ENV === 'production') {
    module.exports = reactIs_production_min;
  } else {
    module.exports = reactIs_development;
  }
});
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

/* eslint-disable no-unused-vars */

var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }

  return Object(val);
}

function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    } // Detect buggy property enumeration order in older V8 versions.
    // https://bugs.chromium.org/p/v8/issues/detail?id=4118


    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

    test1[5] = 'de';

    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test2 = {};

    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }

    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });

    if (order2.join('') !== '0123456789') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });

    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }

    return true;
  } catch (err) {
    // We don't expect any of the above to throw, but better to be safe.
    return false;
  }
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
  var from;
  var to = toObject(target);
  var symbols;

  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);

    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }

    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);

      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }

  return to;
};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1 = ReactPropTypesSecret;

var printWarning = function printWarning() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning = function printWarning(text) {
    var message = 'Warning: ' + text;

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}
/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */


function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error; // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.

        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.');
            err.name = 'Invariant Violation';
            throw err;
          }

          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
        } catch (ex) {
          error = ex;
        }

        if (error && !(error instanceof Error)) {
          printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        }

        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;
          var stack = getStack ? getStack() : '';
          printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
      }
    }
  }
}
/**
 * Resets warning cache when testing.
 *
 * @private
 */


checkPropTypes.resetWarningCache = function () {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes;
var has$1 = Function.call.bind(Object.prototype.hasOwnProperty);

var printWarning$1 = function printWarning$1() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning$1 = function printWarning$1(text) {
    var message = 'Warning: ' + text;

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function factoryWithTypeCheckers(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */

  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);

    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }
  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */


  var ANONYMOUS = '<<anonymous>>'; // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.

  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),
    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker
  };
  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */

  /*eslint-disable no-self-compare*/

  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */


  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  } // Make `instanceof Error` still work for returned errors.


  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }

    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret_1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;

          if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
          manualPropTypeWarningCount < 3) {
            printWarning$1('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }

      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }

          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }

        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }

      var propValue = props[propName];

      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }

      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);

        if (error instanceof Error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning$1('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
        } else {
          printWarning$1('Invalid argument supplied to oneOf, expected an array.');
        }
      }

      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);

        if (type === 'symbol') {
          return String(value);
        }

        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }

    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }

      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }

      for (var key in propValue) {
        if (has$1(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);

          if (error instanceof Error) {
            return error;
          }
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning$1('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];

      if (typeof checker !== 'function') {
        printWarning$1('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];

        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }

    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }

      for (var key in shapeTypes) {
        var checker = shapeTypes[key];

        if (!checker) {
          continue;
        }

        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);

        if (error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      } // We need to check all keys in case some are required but missing from
      // props.


      var allKeys = objectAssign({}, props[propName], shapeTypes);

      for (var key in allKeys) {
        var checker = shapeTypes[key];

        if (!checker) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
        }

        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);

        if (error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;

      case 'boolean':
        return !propValue;

      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }

        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);

        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;

          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;

              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;

      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    } // falsy value can't be a Symbol


    if (!propValue) {
      return false;
    } // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'


    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    } // Fallback for non-spec compliant Symbols which are polyfilled.


    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  } // Equivalent of `typeof` but with special handling for array and regexp.


  function getPropType(propValue) {
    var propType = typeof propValue;

    if (Array.isArray(propValue)) {
      return 'array';
    }

    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }

    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }

    return propType;
  } // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.


  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }

    var propType = getPropType(propValue);

    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }

    return propType;
  } // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"


  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);

    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;

      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;

      default:
        return type;
    }
  } // Returns class name of the object, if any.


  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }

    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes_1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

function emptyFunction() {}

function emptyFunctionWithReset() {}

emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function factoryWithThrowingShims() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      // It is still safe when called from React.
      return;
    }

    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  }

  shim.isRequired = shim;

  function getShim() {
    return shim;
  } // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.


  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

var propTypes = createCommonjsModule(function (module) {
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  if (process.env.NODE_ENV !== 'production') {
    var ReactIs = reactIs; // By explicitly using `prop-types` you are opting into new development behavior.
    // http://fb.me/prop-types-in-prod

    var throwOnDirectAccess = true;
    module.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
  } else {
    // By explicitly using `prop-types` you are opting into new production behavior.
    // http://fb.me/prop-types-in-prod
    module.exports = factoryWithThrowingShims();
  }
});
var G_FUNC = propTypes.func;
var G_BOOL = propTypes.bool;
var G_OBJ = propTypes.object;
var G_STRING = propTypes.string;
var SIZE_PROP = propTypes.oneOf(['small', 'medium', 'large']);
var POSITION_PROP = propTypes.oneOf(['top', 'right', 'bottom', 'left']);
var SELECTION_CONTROL_TYPES = propTypes.oneOf(['radio', 'checkbox', 'switch']);
var TYPOGRAPHY_PROP_TYPES = {
  dark: G_BOOL,
  disabled: G_BOOL,
  secondary: G_BOOL,
  component: G_STRING
};
var SELECTION_CONTROL_PROP_TYPES = {
  id: G_STRING,
  label: G_STRING,
  name: G_STRING,
  checked: G_BOOL,
  required: G_BOOL,
  disabled: G_BOOL,
  color: G_STRING,
  onClick: G_FUNC,
  onChange: G_FUNC
};
var BUTTON_ALTERNATE = propTypes.oneOf(['fab', 'icon', 'toggle']);
var BUTTON_PROP_TYPES = {
  style: G_OBJ,
  dark: G_BOOL,
  text: G_BOOL,
  block: G_BOOL,
  active: G_BOOL,
  rounded: G_BOOL,
  size: SIZE_PROP,
  color: G_STRING,
  outlined: G_BOOL,
  disabled: G_BOOL,
  depressed: G_BOOL,
  onClick: G_FUNC,
  mouseOut: G_FUNC,
  mouseOver: G_FUNC,
  className: G_STRING,
  type: BUTTON_ALTERNATE
};
var BUTTON_GROUP_VALUE = propTypes.oneOfType([propTypes.string, propTypes.array]);

var ToggleButtonGroup =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ToggleButtonGroup, _React$Component);

  function ToggleButtonGroup(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      active: props.value,
      key: 1
    };
    return _this;
  }

  var _proto = ToggleButtonGroup.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(props, state) {
    var active = this.state.active;

    if (JSON.stringify(state.active) !== JSON.stringify(active)) {
      callCallback(props.onChange, {
        active: active
      });
    }
  };

  _proto.handleClick = function handleClick(event) {
    var active = '';
    var selected = event.selected,
        value = event.value;
    var _this$state = this.state,
        key = _this$state.key,
        stateActive = _this$state.active;
    var _this$props = this.props,
        multiple = _this$props.multiple,
        mandatory = _this$props.mandatory,
        onChange = _this$props.onChange;

    if (selected) {
      if (multiple) {
        active = [].concat(stateActive || [], [value]);
      } else {
        active = value;
      }
    } else {
      if (multiple) {
        active = (stateActive || []).filter(function (a) {
          return a !== value;
        });

        if (mandatory && !active.length) {
          active = [value];
        }
      } else {
        if (mandatory) {
          active = value;
        }
      }
    }

    this.setState({
      active: active
    });
    this.setState({
      key: key + 1
    });
    callCallback(onChange, {
      event: event,
      active: active
    });
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props2 = this.props,
        style = _this$props2.style,
        size = _this$props2.size,
        children = _this$props2.children,
        multiple = _this$props2.multiple,
        className = _this$props2.className,
        parentDark = _this$props2.dark;
    var buttons = Children.map(children, function (child) {
      if (child.type === ToggleButton) {
        var selected = false;
        var active = _this2.state.active;
        var _child$props = child.props,
            value = _child$props.value,
            dark = _child$props.dark;

        if (Array.isArray(active)) {
          var trimmedActive = multiple ? active : active.filter(function (a, i) {
            return i === 0;
          });
          selected = !!trimmedActive.find(function (a) {
            return a === value;
          });
        } else {
          selected = active === value;
        }

        return cloneElement(child, {
          size: size,
          selected: selected,
          key: _this2.state.key,
          dark: dark || parentDark,
          onChange: function onChange(e) {
            return _this2.handleClick(e, child);
          }
        });
      }
    });
    return (
      /*#__PURE__*/
      React.createElement("div", {
        style: style,
        className: className
      }, buttons)
    );
  };

  return ToggleButtonGroup;
}(React.Component);

ToggleButtonGroup.displayName = 'NuToggleButtonGroup';
ToggleButtonGroup.propTypes = _extends(_extends({
  multiple: G_BOOL,
  mandatory: G_BOOL
}, BUTTON_PROP_TYPES), {}, {
  value: BUTTON_GROUP_VALUE
});

var ToggleButton =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ToggleButton, _React$Component);

  function ToggleButton(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    var _this$props = _this.props,
        selected = _this$props.selected,
        color = _this$props.color;
    _this.state = {
      isActive: selected || false,
      color: selected ? color : '',
      key: 1
    };
    return _this;
  }

  var _proto = ToggleButton.prototype;

  _proto.handleClick = function handleClick(event) {
    var _this$props2 = this.props,
        value = _this$props2.value,
        color = _this$props2.color,
        onChange = _this$props2.onChange;
    var isActive = !this.state.isActive;
    this.setState({
      isActive: isActive
    });
    this.setState({
      color: isActive ? color : ''
    });
    this.setState({
      key: this.state.key + 1
    });
    callCallback(onChange, {
      event: event,
      selected: isActive,
      value: value
    });
  };

  _proto.handleMouseOut = function handleMouseOut(e) {
    if (!this.state.isActive) {
      this.setState({
        color: ''
      });
    }

    callCallback(this.props.mouseOut, e);
  };

  _proto.handleMouseOver = function handleMouseOver(e) {
    this.setState({
      color: this.props.color
    });
    callCallback(this.props.mouseOver, e);
  };

  _proto.render = function render() {
    var _this2 = this;

    var children = this.props.children;
    return (
      /*#__PURE__*/
      React.createElement(Button, _extends({}, this.props, {
        type: "toggle",
        block: false,
        depressed: false,
        key: this.state.key,
        color: this.state.color,
        active: this.state.isActive,
        onClick: function onClick(e) {
          return _this2.handleClick(e);
        },
        mouseOut: function mouseOut(e) {
          return _this2.handleMouseOut(e);
        },
        mouseOver: function mouseOver(e) {
          return _this2.handleMouseOver(e);
        }
      }), children)
    );
  };

  return ToggleButton;
}(React.Component);

ToggleButton.displayName = 'NuToggleButton';
ToggleButton.defaultProps = {
  text: true
};
ToggleButton.propTypes = _extends({
  value: G_STRING,
  selected: G_BOOL
}, BUTTON_PROP_TYPES);

var IconButton =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(IconButton, _React$Component);

  function IconButton() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = IconButton.prototype;

  _proto.render = function render() {
    var children = this.props.children;
    return (
      /*#__PURE__*/
      React.createElement(Button, _extends({}, this.props, {
        type: "icon",
        block: false,
        depressed: false
      }), children)
    );
  };

  return IconButton;
}(React.Component);

IconButton.displayName = 'NuIconButton';
IconButton.defaultProps = {
  text: true
};
IconButton.propTypes = BUTTON_PROP_TYPES;
var styles = {
  "nu-button": "_cL4RU",
  "nu-button--light": "_CWiZp",
  "nu-button--dark": "_3tLvr",
  "nu-button--fab": "_1YdKB",
  "nu-button--icon": "_2vvr7",
  "nu-button--toggle": "_3hFGr",
  "nu-button--small": "_37by5",
  "nu-button--medium": "_3W7Om",
  "nu-button--large": "_r7kxw",
  "nu-button--block": "_2ULiP",
  "nu-button--rounded": "_39_ND",
  "nu-button--disabled": "_2YNuR",
  "nu-button--text": "_1qWOD",
  "nu-button--outlined": "_1crAB",
  "nu-button--depressed": "_EotAP",
  "nu-button--active": "_28gcN",
  "nu-button-inner": "_3lLt8"
};

var Button =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Button, _React$Component);

  function Button() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Button.prototype;

  _proto.getValidSize = function getValidSize(size) {
    var sizes = ['small', 'medium', 'large'];
    return sizes.find(function (s) {
      return s === size;
    }) || 'medium';
  };

  _proto.getClasses = function getClasses(classType) {
    var _this$props = this.props,
        type = _this$props.type,
        dark = _this$props.dark,
        size = _this$props.size,
        text = _this$props.text,
        block = _this$props.block,
        active = _this$props.active,
        rounded = _this$props.rounded,
        disabled = _this$props.disabled,
        outlined = _this$props.outlined,
        depressed = _this$props.depressed;

    switch (classType) {
      case 'container':
        return getModuleClasses(styles, "\n            nu-button\n            cursor-pointer\n            nu-button--" + type + "\n            " + (text ? 'nu-button--text' : '') + "\n            " + (block ? 'nu-button--block' : '') + "\n            " + (active ? 'nu-button--active' : '') + "\n            nu-button--" + this.getValidSize(size) + "\n            nu-button--" + (dark ? 'dark' : 'light') + "\n            " + (rounded ? 'nu-button--rounded' : '') + "\n            " + (outlined ? 'nu-button--outlined' : '') + "\n            " + (disabled ? 'nu-button--disabled' : '') + "\n            " + (depressed ? 'nu-button--depressed' : '') + "\n          ");

      case 'input':
        return getModuleClasses(styles, 'nu-button-inner');
    }
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        type = _this$props2.type,
        style = _this$props2.style,
        color = _this$props2.color,
        bgColor = _this$props2.bgColor,
        disabled = _this$props2.disabled,
        outlined = _this$props2.outlined,
        children = _this$props2.children,
        className = _this$props2.className;
    var _this$props3 = this.props,
        onClick = _this$props3.onClick,
        mouseOver = _this$props3.mouseOver,
        mouseOut = _this$props3.mouseOut;
    var btnChildren = passDownProp(children, this.props, 'dark');
    return (
      /*#__PURE__*/
      React.createElement("div", {
        onClick: onClick,
        onMouseOut: mouseOut,
        onMouseOver: mouseOver,
        className: this.getClasses('container') + " " + className,
        style: _extends(_extends({}, style), {}, {
          color: disabled ? null : color,
          backgroundColor: disabled ? null : bgColor,
          border: disabled ? null : outlined ? "1px solid " + color : null
        })
      },
      /*#__PURE__*/
      React.createElement("button", {
        className: this.getClasses('input')
      }, type ? btnChildren : btnChildren || 'button'))
    );
  };

  return Button;
}(React.Component);

Button.displayName = 'NuButton';
Button.defaultProps = {
  size: 'medium'
};
Button.propTypes = BUTTON_PROP_TYPES;
var styles$1 = {
  "nu-fab": "_3RmuL",
  "nu-fab--animation": "_3XYq8",
  "fab-animate": "_2xXgg",
  "nu-fab--fixed": "_2fQ45",
  "nu-fab--absolute": "_1yPi-",
  "nu-fab--top": "_MXoMR",
  "nu-fab--right": "_39m3p",
  "nu-fab--bottom": "_1SKZA",
  "nu-fab--left": "_300yT"
};

var Fab =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Fab, _React$Component);

  function Fab() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Fab.prototype;

  _proto.getClasses = function getClasses() {
    var _this$props = this.props,
        fixed = _this$props.fixed,
        top = _this$props.top,
        right = _this$props.right,
        bottom = _this$props.bottom,
        left = _this$props.left,
        absolute = _this$props.absolute,
        animation = _this$props.animation;
    return getModuleClasses(styles$1, "\n        nu-fab\n        " + (top ? 'nu-fab--top' : '') + "\n        " + (left ? 'nu-fab--left' : '') + "\n        " + (right ? 'nu-fab--right' : '') + "\n        " + (bottom ? 'nu-fab--bottom' : '') + "\n        " + (fixed ? 'nu-fab--fixed' : '') + "\n        " + (absolute ? 'nu-fab--absolute' : '') + "\n        " + (animation ? 'nu-fab--animation' : '') + "\n      ");
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        children = _this$props2.children,
        style = _this$props2.style,
        className = _this$props2.className;
    return (
      /*#__PURE__*/
      React.createElement("div", {
        style: style,
        className: this.getClasses() + " " + className
      },
      /*#__PURE__*/
      React.createElement(Button, _extends({}, this.props, {
        rounded: true,
        type: "fab",
        style: {},
        className: "",
        text: false,
        block: false,
        depressed: false
      }), children))
    );
  };

  return Fab;
}(React.Component);

Fab.displayName = 'NuFab';
Fab.defaultProps = {
  animation: true
};
Fab.propTypes = _extends({
  top: G_BOOL,
  left: G_BOOL,
  right: G_BOOL,
  bottom: G_BOOL,
  fixed: G_BOOL,
  absolute: G_BOOL,
  animation: G_BOOL
}, BUTTON_PROP_TYPES);
var styles$2 = {
  "nu-card": "_28vIk",
  "nu-card-action": "_qCt7a",
  "nu-card-content": "_2So3v",
  "nu-card--light": "_1SFBz",
  "nu-card-action--light": "_1l5Ig",
  "nu-card-content--light": "_2uw1B",
  "nu-card--dark": "_2nMGC",
  "nu-card-action--dark": "_1e8rA",
  "nu-card-content--dark": "_BClU8",
  "nu-card--rounded": "_1qJ6l",
  "nu-card-action--rounded": "_3MMHx",
  "nu-card-content--rounded": "_1xGVC",
  "nu-card--outlined": "_2BfgR",
  "nu-card--flat": "_PR9zj",
  "elevation-5": "_1ac5u",
  "elevation-4": "_33saR",
  "elevation-3": "_2Y5h3",
  "elevation-2": "_3hBYZ",
  "elevation-1": "_2bGnb",
  "elevation-0": "_2xWhy"
};

var CardContent =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(CardContent, _React$Component);

  function CardContent() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = CardContent.prototype;

  _proto.getClass = function getClass() {
    var _this$props = this.props,
        dark = _this$props.dark,
        rounded = _this$props.rounded;
    return getModuleClasses(styles$2, "\n        nu-card-content\n        nu-card-content--" + (dark ? 'dark' : 'light') + "\n        " + (rounded ? 'nu-card-content--rounded' : '') + "\n      ");
  };

  _proto.render = function render() {
    var cardChildren = passDownProp(this.props.children, this.props, ['dark', 'rounded']);
    return (
      /*#__PURE__*/
      React.createElement("div", {
        className: this.getClass()
      }, cardChildren || 'card-content')
    );
  };

  return CardContent;
}(React.Component);

CardContent.displayName = 'NuCardContent';
CardContent.propTypes = {
  dark: G_BOOL,
  rounded: G_BOOL
};

var CardAction =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(CardAction, _React$Component);

  function CardAction() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = CardAction.prototype;

  _proto.getClass = function getClass() {
    var _this$props = this.props,
        dark = _this$props.dark,
        rounded = _this$props.rounded;
    return getModuleClasses(styles$2, "\n        nu-card-action\n        nu-card-action--" + (dark ? 'dark' : 'light') + "\n        " + (rounded ? 'nu-card-action--rounded' : '') + "\n      ");
  };

  _proto.render = function render() {
    var cardChildren = passDownProp(this.props.children, this.props, ['dark', 'rounded']);
    return (
      /*#__PURE__*/
      React.createElement("div", {
        className: this.getClass()
      }, cardChildren || 'card-action')
    );
  };

  return CardAction;
}(React.Component);

CardAction.displayName = 'NuCardAction';
CardAction.propTypes = {
  dark: G_BOOL,
  rounded: G_BOOL
};

var Card =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Card, _React$Component);

  function Card() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Card.prototype;

  _proto.getClass = function getClass() {
    var _this$props = this.props,
        dark = _this$props.dark,
        flat = _this$props.flat,
        elevation = _this$props.elevation,
        rounded = _this$props.rounded,
        outlined = _this$props.outlined;
    return getModuleClasses(styles$2, "\n        nu-card\n        elevation-" + (elevation || '1') + "\n        " + (flat ? 'nu-card--flat' : '') + "\n        nu-card--" + (dark ? 'dark' : 'light') + "\n        " + (rounded ? 'nu-card--rounded' : '') + "\n        " + (outlined ? 'nu-card--outlined' : '') + "\n      ");
  };

  _proto.render = function render() {
    var cardChildren = passDownProp(this.props.children, this.props, ['dark', 'rounded', 'outlined']);
    return (
      /*#__PURE__*/
      React.createElement("div", {
        style: _extends({}, this.props.style),
        className: this.getClass()
      }, cardChildren)
    );
  };

  return Card;
}(React.Component);

Card.displayName = 'NuCard';
Card.propTypes = {
  dark: G_BOOL,
  flat: G_BOOL,
  rounded: G_BOOL,
  outlined: G_BOOL,
  elevation: G_STRING
};
var styles$3 = {
  "nu-h1": "_2RF0y",
  "nu-h2": "_2b-UI",
  "nu-h3": "_rTEEr",
  "nu-h4": "_1N96j",
  "nu-h5": "_2TwOi",
  "nu-h6": "_2wZct",
  "nu-subtitle-1": "_2BgaH",
  "nu-subtitle-2": "_2vNlX",
  "nu-body-1": "_NwSHs",
  "nu-body-2": "_i_J81",
  "nu-caption": "_2HbLl",
  "nu-overline": "_1yuzT",
  "nu-typography": "_3yPwv",
  "nu-typography--primary": "_11JjB",
  "nu-typography--light": "_1uvOH",
  "nu-typography--dark": "_3PUqy",
  "nu-typography--secondary": "_1QRSN",
  "nu-typography--disabled": "_31wpR"
};

var Typography =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Typography, _React$Component);

  function Typography() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.mapping = {
      h1: 'h1',
      h2: 'h2',
      h3: 'h3',
      h4: 'h4',
      h5: 'h5',
      h6: 'h6',
      caption: 'p',
      overline: 'p',
      'subtitle-1': 'p',
      'subtitle-2': 'p',
      'body-1': 'p',
      'body-2': 'p'
    };
    return _this;
  }

  var _proto = Typography.prototype;

  _proto.getTypographyType = function getTypographyType() {
    var _this$props = this.props,
        disabled = _this$props.disabled,
        secondary = _this$props.secondary;
    return disabled ? 'disabled' : secondary ? 'secondary' : 'primary';
  };

  _proto.getMapping = function getMapping() {
    var _this$props2 = this.props,
        type = _this$props2.type,
        component = _this$props2.component;
    return component || this.mapping[type || 'body-1'];
  };

  _proto.getClass = function getClass() {
    var _this$props3 = this.props,
        dark = _this$props3.dark,
        type = _this$props3.type;
    return getModuleClasses(styles$3, "\n        nu-typography\n        nu-" + (type || 'body-1') + "\n        nu-typography--" + this.getTypographyType() + "\n        nu-typography--" + (dark ? 'dark' : 'light') + "\n      ");
  };

  _proto.render = function render() {
    return createElement(this.getMapping(), {
      style: this.props.style,
      className: this.getClass()
    }, this.props.children);
  };

  return Typography;
}(React.Component);

Typography.displayName = 'NuTypography';
Typography.propTypes = _extends({
  type: G_STRING
}, TYPOGRAPHY_PROP_TYPES);

var H1 =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(H1, _React$Component);

  function H1() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = H1.prototype;

  _proto.render = function render() {
    return (
      /*#__PURE__*/
      React.createElement(Typography, _extends({}, this.props, {
        type: "h1"
      }), this.props.children)
    );
  };

  return H1;
}(React.Component);

H1.displayName = 'NuH1';
H1.propTypes = TYPOGRAPHY_PROP_TYPES;

var H2 =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(H2, _React$Component);

  function H2() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = H2.prototype;

  _proto.render = function render() {
    return (
      /*#__PURE__*/
      React.createElement(Typography, _extends({}, this.props, {
        type: "h2"
      }), this.props.children)
    );
  };

  return H2;
}(React.Component);

H2.displayName = 'NuH2';
H2.propTypes = TYPOGRAPHY_PROP_TYPES;

var H3 =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(H3, _React$Component);

  function H3() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = H3.prototype;

  _proto.render = function render() {
    return (
      /*#__PURE__*/
      React.createElement(Typography, _extends({}, this.props, {
        type: "h3"
      }), this.props.children)
    );
  };

  return H3;
}(React.Component);

H3.displayName = 'NuH3';
H3.propTypes = TYPOGRAPHY_PROP_TYPES;

var H4 =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(H4, _React$Component);

  function H4() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = H4.prototype;

  _proto.render = function render() {
    return (
      /*#__PURE__*/
      React.createElement(Typography, _extends({}, this.props, {
        type: "h4"
      }), this.props.children)
    );
  };

  return H4;
}(React.Component);

H4.displayName = 'NuH4';
H4.propTypes = TYPOGRAPHY_PROP_TYPES;

var H5 =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(H5, _React$Component);

  function H5() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = H5.prototype;

  _proto.render = function render() {
    return (
      /*#__PURE__*/
      React.createElement(Typography, _extends({}, this.props, {
        type: "h5"
      }), this.props.children)
    );
  };

  return H5;
}(React.Component);

H5.displayName = 'NuH5';
H5.propTypes = TYPOGRAPHY_PROP_TYPES;

var H6 =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(H6, _React$Component);

  function H6() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = H6.prototype;

  _proto.render = function render() {
    return (
      /*#__PURE__*/
      React.createElement(Typography, _extends({}, this.props, {
        type: "h6"
      }), this.props.children)
    );
  };

  return H6;
}(React.Component);

H6.displayName = 'NuH6';
H6.propTypes = TYPOGRAPHY_PROP_TYPES;

var Body1 =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Body1, _React$Component);

  function Body1() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Body1.prototype;

  _proto.render = function render() {
    return (
      /*#__PURE__*/
      React.createElement(Typography, _extends({}, this.props, {
        type: "body-1"
      }), this.props.children)
    );
  };

  return Body1;
}(React.Component);

Body1.displayName = 'NuBody1';
Body1.propTypes = TYPOGRAPHY_PROP_TYPES;

var Body2 =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Body2, _React$Component);

  function Body2() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Body2.prototype;

  _proto.render = function render() {
    return (
      /*#__PURE__*/
      React.createElement(Typography, _extends({}, this.props, {
        type: "body-2"
      }), this.props.children)
    );
  };

  return Body2;
}(React.Component);

Body2.displayName = 'NuBody2';
Body2.propTypes = TYPOGRAPHY_PROP_TYPES;

var Caption =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Caption, _React$Component);

  function Caption() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Caption.prototype;

  _proto.render = function render() {
    return (
      /*#__PURE__*/
      React.createElement(Typography, _extends({}, this.props, {
        type: "caption"
      }), this.props.children)
    );
  };

  return Caption;
}(React.Component);

Caption.displayName = 'NuCaption';
Caption.propTypes = TYPOGRAPHY_PROP_TYPES;

var Overline =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Overline, _React$Component);

  function Overline() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Overline.prototype;

  _proto.render = function render() {
    return (
      /*#__PURE__*/
      React.createElement(Typography, _extends({}, this.props, {
        type: "overline"
      }), this.props.children)
    );
  };

  return Overline;
}(React.Component);

Overline.displayName = 'NuOverline';
Overline.propTypes = TYPOGRAPHY_PROP_TYPES;

var Subtitle1 =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Subtitle1, _React$Component);

  function Subtitle1() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Subtitle1.prototype;

  _proto.render = function render() {
    return (
      /*#__PURE__*/
      React.createElement(Typography, _extends({}, this.props, {
        type: "subtitle-1"
      }), this.props.children)
    );
  };

  return Subtitle1;
}(React.Component);

Subtitle1.displayName = 'NuSubtitle1';
Subtitle1.propTypes = TYPOGRAPHY_PROP_TYPES;

var Subtitle2 =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Subtitle2, _React$Component);

  function Subtitle2() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Subtitle2.prototype;

  _proto.render = function render() {
    return (
      /*#__PURE__*/
      React.createElement(Typography, _extends({}, this.props, {
        type: "subtitle-2"
      }), this.props.children)
    );
  };

  return Subtitle2;
}(React.Component);

Subtitle2.displayName = 'NuSubtitle2';
Subtitle2.propTypes = TYPOGRAPHY_PROP_TYPES;
var styles$4 = {
  "nu-divider": "_1RYKi",
  "nu-divider--light": "_1P-G7",
  "nu-divider--dark": "_OnFhH",
  "nu-divider--dense": "_2u50z",
  "nu-divider--elevated": "_3O_dH"
};

var Divider =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Divider, _React$Component);

  function Divider() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Divider.prototype;

  _proto.getClasses = function getClasses() {
    var _this$props = this.props,
        dark = _this$props.dark,
        dense = _this$props.dense,
        elevated = _this$props.elevated;
    return getModuleClasses(styles$4, "\n        nu-divider\n        " + (dense ? 'nu-divider--dense' : '') + "\n        nu-divider--" + (dark ? 'dark' : 'light') + "\n        " + (elevated ? 'nu-divider--elevated' : '') + "\n      ");
  };

  _proto.render = function render() {
    return (
      /*#__PURE__*/
      React.createElement("hr", {
        style: _extends({}, this.props.style),
        className: this.getClasses()
      })
    );
  };

  return Divider;
}(React.Component);

Divider.displayName = 'NuDivider';
Divider.propTypes = {
  dark: G_BOOL,
  dense: G_BOOL,
  elevated: G_BOOL
};

var Radio =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Radio, _React$Component);

  function Radio() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Radio.prototype;

  _proto.render = function render() {
    return (
      /*#__PURE__*/
      React.createElement(SelectionControl, _extends({
        type: "radio"
      }, this.props))
    );
  };

  return Radio;
}(React.Component);

Radio.displayName = 'NuRadio';
Radio.propTypes = SELECTION_CONTROL_PROP_TYPES;

var Switch =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Switch, _React$Component);

  function Switch() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Switch.prototype;

  _proto.render = function render() {
    return (
      /*#__PURE__*/
      React.createElement(SelectionControl, _extends({
        type: "switch"
      }, this.props))
    );
  };

  return Switch;
}(React.Component);

Switch.displayName = 'NuSwitch';
Switch.propTypes = SELECTION_CONTROL_PROP_TYPES;

var Checkbox =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Checkbox, _React$Component);

  function Checkbox() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Checkbox.prototype;

  _proto.render = function render() {
    return (
      /*#__PURE__*/
      React.createElement(SelectionControl, _extends({
        type: "checkbox"
      }, this.props))
    );
  };

  return Checkbox;
}(React.Component);

Checkbox.displayName = 'NuCheckbox';
Checkbox.propTypes = SELECTION_CONTROL_PROP_TYPES;
var radioStyles = {
  "nu-radio": "_2g7Fh",
  "nu-radio--light": "_37QLn",
  "nu-radio--dark": "_nacDr",
  "nu-radio--disabled": "_24Y84",
  "nu-radio-label": "_30uF4",
  "nu-radio-label--disabled": "_1EeO5"
};
var checkboxStyles = {
  "nu-checkbox": "_2DIew",
  "nu-checkbox--light": "_1u_cB",
  "nu-checkbox--dark": "_a77__",
  "checkbox-check": "_JRLap",
  "checkbox-uncheck": "_BF55r",
  "nu-checkbox--disabled": "_2qmYE",
  "nu-checkbox-label": "_aIUGu",
  "nu-checkbox-label--disabled": "_3QbeY"
};
var switchStyles = {
  "nu-switch": "_AQLzt",
  "nu-switch--light": "_1zQ0s",
  "nu-switch--dark": "_BQ4h8",
  "nu-switch--disabled": "_C4xuu",
  "nu-switch-label": "_2hoJO"
};

var SelectionControl =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(SelectionControl, _React$Component);

  function SelectionControl(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      id: "" + uid() + (_this.props.value || ''),
      isChecked: props.checked || false,
      type: props.type,
      styles: {
        radioStyles: radioStyles,
        switchStyles: switchStyles,
        checkboxStyles: checkboxStyles
      }
    };
    return _this;
  }

  var _proto = SelectionControl.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this$props = this.props,
        id = _this$props.id,
        color = _this$props.color,
        disabled = _this$props.disabled;
    var elem = document.getElementById(id || this.state.id);

    if (!disabled) {
      setCSSVariable(elem, '--selector-bg', color);
    }
  };

  _proto.handleChange = function handleChange(event) {
    var isChecked = event.target.checked;
    this.setState({
      isChecked: isChecked
    });
    var onChange = this.props.onChange;

    if (onChange) {
      onChange({
        event: event,
        checked: isChecked
      });
    }
  };

  _proto.getInputType = function getInputType(type) {
    return ['radio', 'checkbox', 'switch'].find(function (i) {
      return i === type;
    }) || 'checkbox';
  };

  _proto.getClasses = function getClasses(elem) {
    var _this$props2 = this.props,
        dark = _this$props2.dark,
        disabled = _this$props2.disabled;
    var _this$state = this.state,
        inputType = _this$state.type,
        styles = _this$state.styles;
    var type = this.getInputType(inputType);
    var style = styles[type + "Styles"];
    var disabledInputClass = disabled ? "nu-" + type + "--disabled" : '';
    var disabledLabelClass = disabled ? "nu-" + type + "-label--disabled" : 'cursor-pointer';

    switch (elem) {
      case 'container':
        return getModuleClasses({}, 'selection-control-container');

      case 'input':
        return getModuleClasses(style, "\n            nu-" + type + "\n            " + disabledInputClass + "\n            nu-" + type + "--" + (dark ? 'dark' : 'light') + "\n          ");

      case 'label':
        return getModuleClasses(style, "\n            nu-" + type + "-label\n            " + disabledLabelClass + "\n          ");
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props3 = this.props,
        id = _this$props3.id,
        dark = _this$props3.dark,
        name = _this$props3.name,
        value = _this$props3.value,
        style = _this$props3.style,
        label = _this$props3.label,
        disabled = _this$props3.disabled,
        required = _this$props3.required,
        onClick = _this$props3.onClick;
    var _this$state2 = this.state,
        stateId = _this$state2.id,
        type = _this$state2.type,
        isChecked = _this$state2.isChecked;
    var inputType = this.getInputType(type);
    return (
      /*#__PURE__*/
      React.createElement("div", {
        className: this.getClasses('container'),
        style: _extends({}, style)
      },
      /*#__PURE__*/
      React.createElement("input", {
        name: name,
        value: value,
        onClick: onClick,
        id: id || stateId,
        required: required,
        disabled: disabled,
        checked: isChecked,
        className: this.getClasses('input'),
        onChange: function onChange(e) {
          return _this2.handleChange(e);
        },
        type: inputType === 'switch' ? 'checkbox' : inputType
      }),
      /*#__PURE__*/
      React.createElement("label", {
        htmlFor: id || stateId,
        className: this.getClasses('label')
      },
      /*#__PURE__*/
      React.createElement(Body1, {
        dark: dark,
        disabled: disabled
      }, label)))
    );
  };

  return SelectionControl;
}(React.Component);

SelectionControl.displayName = 'NuSelectionControl';
SelectionControl.propTypes = _extends(_extends({}, SELECTION_CONTROL_PROP_TYPES), {}, {
  type: SELECTION_CONTROL_TYPES.isRequired
});
export { Body1, Body2, Button, Caption, Card, CardAction, CardContent, Checkbox, Divider, Fab, H1, H2, H3, H4, H5, H6, IconButton, Overline, Radio, SelectionControl, Subtitle1, Subtitle2, Switch, ToggleButton, ToggleButtonGroup, Typography, overrideThemeVariables };